import moment from 'moment';

export const getDistricts = (item) => {
  if (!item) return null;
  return item.districts;
};

export const getCommunities = (district) => {
  if (!district) return null;
  return district.communities;
};

export const getCommunityInfo = (community) => {
  if (!community) return null;
  return {
    name: community.communityName,
    joiningDate: moment(community.regTime).format('DD.MM.YYYY'),
  };
};

export const getCommunityApplyInfo = (community) => {
  if (!community) return null;
  return {
    name: community.communityName,
    applicationDate: moment(community.regTime).format('DD.MM.YYYY'),
  };
};

export const getCommunitiesArray = (data) => {
  if (!data) return null;
  const array = [];

  data.forEach((item) => {
    const districts = getDistricts(item);

    districts.forEach((district) => {
      const communities = getCommunities(district);

      communities.forEach((community) => {
        // info about local community
        const info = getCommunityInfo(community);
        array.push(info);
      });
    });
  });

  return array;
};

export const sortArrayByField = (array, field) => {
  array.sort((one, other) => one[field].localeCompare(other[field]));
};

export const prepareJoiningDataset = (dataSet) => {
  const array = [];

  dataSet.forEach((regionItem) => {
    const region = regionItem.regionName;
    regionItem.districts.forEach((districtItem) => {
      const district = districtItem.districtName;
      districtItem.communities.forEach((communityItem) => {
        let districtName = district;

        if (!districtName.includes('м.')) {
          if (districtName.includes('Якимівський')) console.log('Якимівський:', districtName);
          districtName += ' район';
        }

        array.push([
          { value: region + ' область' },
          { value: districtName },
          { value: communityItem.name },
          { value: communityItem.joiningDate },
        ]);
      });
    });
  });

  return [
    {
      columns: [
        { title: 'Назва області', width: { wch: 30 } }, //char width
        { title: 'Назва району', width: { wch: 30 } },
        { title: 'Назва ТГ', width: { wch: 60 } },
        { title: 'Дата приєднання', width: { wch: 14 } },
      ],
      data: array,
    },
  ];
};

export const prepareApplicationDataset = (dataSet) => {
  const array = [];

  dataSet.forEach((regionItem) => {
    const region = regionItem.regionName;
    regionItem.districts.forEach((districtItem) => {
      const district = districtItem.districtName;
      districtItem.communities.forEach((communityItem) => {
        array.push([
          { value: region },
          { value: district },
          { value: communityItem.name },
          { value: communityItem.applicationDate },
        ]);
      });
    });
  });

  return [
    {
      columns: [
        { title: 'Назва області', width: { wch: 30 } }, //char width
        { title: 'Назва району', width: { wch: 30 } },
        { title: 'Назва ТГ', width: { wch: 60 } },
        { title: 'Дата заявки', width: { wch: 14 } },
      ],
      data: array,
    },
  ];
};
